import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Shield } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-cream-50 text-charcoal-500 pt-6 pb-10 px-4" data-id="element-53">
        <div className="max-w-3xl mx-auto text-center text-xs space-y-3 border-t border-cream-200 pt-6" data-id="element-54">
          <p data-id="element-55">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
          <p className="font-medium" data-id="element-56">
            © {new Date().getFullYear()} Kit de Loncheras. Todos los derechos
            reservados.
          </p>
          <button onClick={() => setShowPrivacy(true)} className="inline-flex items-center gap-1.5 text-charcoal-500 hover:text-naranja-500 underline underline-offset-2 transition-colors font-medium" data-id="element-57">
            <Shield className="w-3.5 h-3.5" data-id="element-58" />
            Política de Privacidad
          </button>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-59">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-60">
            <motion.div initial={{
          opacity: 0,
          scale: 0.92,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.92,
          y: 20
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 22
        }} className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-61">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-cream-200 bg-cream-50" data-id="element-62">
                <div className="flex items-center gap-2" data-id="element-63">
                  <Shield className="w-5 h-5 text-azul-naval-500" data-id="element-64" />
                  <h3 className="text-lg font-black text-charcoal-900" data-id="element-65">
                    Política de Privacidad
                  </h3>
                </div>
                <button onClick={() => setShowPrivacy(false)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-cream-200 transition-colors text-charcoal-500" data-id="element-66">
                  <X className="w-5 h-5" data-id="element-67" />
                </button>
              </div>

              {/* Content */}
              <div className="px-6 py-5 overflow-y-auto max-h-[60vh] text-sm text-charcoal-700 space-y-4 leading-relaxed" data-id="element-68">
                <p className="text-xs text-charcoal-400 font-medium" data-id="element-69">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
                </p>

                <h4 className="font-bold text-charcoal-900" data-id="element-70">
                  1. Información que recopilamos
                </h4>
                <p data-id="element-71">
                  Recopilamos únicamente la información que nos proporcionas
                  voluntariamente al realizar una compra, como tu nombre y
                  correo electrónico. No recopilamos datos sensibles ni
                  compartimos tu información con terceros.
                </p>

                <h4 className="font-bold text-charcoal-900" data-id="element-72">
                  2. Uso de la información
                </h4>
                <p data-id="element-73">
                  La información recopilada se utiliza exclusivamente para
                  procesar tu compra, enviarte el producto digital adquirido y
                  brindarte soporte relacionado con tu pedido.
                </p>

                <h4 className="font-bold text-charcoal-900" data-id="element-74">
                  3. Protección de datos
                </h4>
                <p data-id="element-75">
                  Implementamos medidas de seguridad para proteger tu
                  información personal. Tus datos de pago son procesados de
                  forma segura a través de plataformas de pago certificadas y
                  nunca almacenamos información de tarjetas de crédito.
                </p>

                <h4 className="font-bold text-charcoal-900" data-id="element-76">4. Cookies</h4>
                <p data-id="element-77">
                  Este sitio puede utilizar cookies para mejorar tu experiencia
                  de navegación y analizar el tráfico del sitio. Puedes
                  desactivar las cookies en la configuración de tu navegador.
                </p>

                <h4 className="font-bold text-charcoal-900" data-id="element-78">
                  5. Derechos del usuario
                </h4>
                <p data-id="element-79">
                  Tienes derecho a acceder, rectificar o eliminar tus datos
                  personales en cualquier momento. También puedes solicitar la
                  cancelación de comunicaciones promocionales.
                </p>

                <h4 className="font-bold text-charcoal-900" data-id="element-80">
                  6. Cambios en esta política
                </h4>
                <p data-id="element-81">
                  Nos reservamos el derecho de actualizar esta política de
                  privacidad en cualquier momento. Los cambios serán publicados
                  en esta misma página.
                </p>
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-cream-200 bg-cream-50" data-id="element-82">
                <button onClick={() => setShowPrivacy(false)} className="w-full bg-azul-naval-500 hover:bg-azul-naval-600 text-white font-bold py-2.5 rounded-xl transition-colors text-sm" data-id="element-83">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}